// CSV exports for the Overview's Zones panel: one row per zone per selected game, over the
// Overview's time window. Same layout as DwellExportButton.js, plus the window each row covers.
import { minuteToClock } from './overviewMetrics';

const quote = (text) => `"${String(text ?? '').replace(/"/g, '""')}"`;

const slug = (text) =>
  String(text || 'store')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// e.g. royals-team-store_dwell_2026-04-12_to_2026-04-15.csv (one game: ..._2026-04-12.csv)
export const zoneExportFilename = (storeName, metric, dates) => {
  const sorted = [...dates].sort();
  const range = sorted.length > 1 && sorted[0] !== sorted[sorted.length - 1]
    ? `${sorted[0]}_to_${sorted[sorted.length - 1]}`
    : sorted[0];
  return `${slug(storeName)}_${metric}_${range}.csv`;
};

// rows: [{ gameDate, zoneId, zoneLabel, windowStart, windowEnd, value, extra? }]
// extraHeaders: more columns after the value, read from each row's `extra` array
export const buildZoneCsv = (rows, valueHeader, extraHeaders = []) => {
  const header = ['gameDate', 'zoneId', 'zoneLabel', 'windowStart', 'windowEnd', valueHeader, ...extraHeaders];
  const lines = [header.join(',')];
  rows.forEach((r) => {
    const extra = extraHeaders.map((_, i) => r.extra?.[i] ?? '');
    lines.push([r.gameDate, r.zoneId, quote(r.zoneLabel), r.windowStart, r.windowEnd, r.value ?? '', ...extra].join(','));
  });
  return lines.join('\n');
};

// Rows for every selected game (by date) and zone (by id), from the Overview's own numbers.
// pick(occupancy, zoneId) returns the value; pickExtra (optional) returns extra column values.
export const zoneExportRows = (cards, zones, zoneName, pick, pickExtra) =>
  [...cards]
    .filter((c) => c.m?.occupancy)
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0))
    .flatMap((c) => [...zones]
      .sort((a, b) => a.id - b.id)
      .map((z) => ({
        gameDate: c.date,
        zoneId: z.id,
        zoneLabel: zoneName(z.id),
        windowStart: minuteToClock(c.m.windowStart),
        windowEnd: minuteToClock(c.m.windowEnd),
        value: pick(c.m.occupancy, z.id),
        extra: pickExtra ? pickExtra(c.m.occupancy, z.id) : undefined,
      })));

export const downloadCsv = (filename, csv) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
